<template>
  <ConfirmPopup></ConfirmPopup>
        <Panel header="Cập nhật thông tin dân cư">
          <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
          <div class="flex min-w-0 flex-col md:col-span-3">
            <label>Họ và tên</label>
            <InputText id="username" type="text" v-model="customer.fullName" />
          </div>
          <div class="flex min-w-0 flex-col md:col-span-3">
            <label>Địa chỉ</label>
            <InputText id="address" v-model="customer.address"/>
          </div>
          <div class="flex min-w-0 flex-col md:col-span-3">
            <label>Giới tính</label>
            <Dropdown id="gender" v-model="customer.gender" :options="genderList" optionLabel="value" optionValue="value" :filter="true" />
          </div>
          <div class="flex min-w-0 flex-col md:col-span-3">
            <label>Số điện thoại</label>
            <InputText id="phoneNumber" type="text" v-model="customer.phoneNumber" />
          </div>
          <div class="flex min-w-0 flex-col md:col-span-3">
            <label>Tổ</label>
            <Dropdown id="civilGroup" v-model="customer.idCivilGroup" :options="listCivilGroup" optionLabel="civilGroupName" optionValue="id" :filter="true">
            </Dropdown>
          </div>
      </div>

      <Button label="Cập nhật" icon="pi pi-sync" iconPos="left" @click="doUpdate()" class="mr-[2vw] w-[15vw]"/>
<!--          </div>-->
        </Panel>
</template>

<script lang="ts">

import { computed, ref } from 'vue'
import AuthRepository from '@/services/AuthRepository'
import { useToast } from "@/ui/services/toast";
import { useRouter } from 'vue-router'
import {useStore} from "vuex";
import {useConfirm} from "@/ui/services/confirm";
import moment from "moment";
import {UserUpdate} from "@/models/userUpdate";
import Ward from "@/models/Ward.models";
import CivilGroup from "@/models/CivilGroup.models";
import zaloRepository from "@/services/ZaloRepository";
import router from "@/router";
import {CustomerUpdate} from "@/models/customerUpdate";

export default {
  props: {
    id: Number,
  },

  setup(props) {
    const router = useRouter();
    const userUpdate = ref({} as UserUpdate);
    const toast = useToast();
    const store = useStore();
    const listCivilGroup = ref([] as CivilGroup[]);
    const genderList = ref([
      { label: 'nam', value: 'nam' },
      { label: 'nữ', value: 'nữ' },
    ]);
    // if(!(store.state.permission == "admin")){
    //   router.push({
    //     name: 'home'
    //   });
    // }
    const customer = ref({} as CustomerUpdate);

    // const valid = computed(()=> {
    //   console.log("$$$$$$$############### debug permission: " + userUpdate.value.permission);
    //   if(userUpdate.value.permission == "civilGroup")
    //   {
    //     return userUpdate.value.fullname&&userUpdate.value.username&&civilGroup.value.wardCode;
    //   }
    //   else if(userUpdate.value.permission == "ward")
    //   {
    //     return userUpdate.value.fullname&&userUpdate.value.username;
    //   }
    //   else if((userUpdate.value.permission == "district")||(userUpdate.value.permission == "admin")) {
    //     return userUpdate.value.fullname&&userUpdate.value.username;
    //   }
    // });

    const doUpdate = () => {
      zaloRepository.updateCustomerByUser(customer.value)
          .then((response) => {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail:'Cập nhật dân cư thành công',
              life: 2000
            });
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    zaloRepository.getCustomerById(props.id)
        .then((response) => {
          customer.value = response.data;
        })
        .catch(err => {
          toast.add({
            severity: 'error',
            summary: 'Lỗi',
            detail:err.response.data,
            life: 2000
          });
        });

    zaloRepository.getListCivilGroup()
        .then((response) => {
          listCivilGroup.value = response.data;
        })
        .catch(err => {
          toast.add({
            severity: 'error',
            summary: 'Lỗi',
            detail:err.response.data,
            life: 2000
          });
        });

    return {
      userUpdate,
      customer,
      genderList,
      listCivilGroup,
      doUpdate,
    }
  }
}

</script>
